module.exports = __webpack_public_path__ + "static/img/zg1.3459ac2.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/zg1.png
// module id = gzb8
// module chunks = 1